import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

//Vue 화면에서 Store의 state와 getter를 import 하기 편하도록 함
export const rootComputed = {
	...mapState('commonStore', Object.keys(state)),
	...mapGetters('commonStore', Object.keys(getters))
};

//Vue 화면에서 Store의 action과 mutation을 import 하기 편하도록 함
export const rootMethods = {
	...mapActions('commonStore', Object.keys(actions)),
	...mapMutations('commonStore', Object.keys(mutations))
};
